export default "__VITE_ASSET__YoLqu8AK__"